<modal modalClass="modal-lg" #forwardModal (onOpen)="onOpen()" (onClose)="close($event)">
  <modal-header>
    <h3>Request a response</h3>
  </modal-header>
  <modal-content (click)="closeTooltip()">
    <div>
      <div class="form-group">
        <div class="row">
          <div class="col-md-10">
            <label class="" for="inputResponder">Responders :</label>
          </div>
          <div class="col-md-2">
            <label class=""><a (click)="openSearch()">Add</a></label>
          </div>
        </div>
        @if (!isValid) {
          <label class="validation-fail">Need to add atleast one responder to forward.</label>
        }
      </div>
    </div>
    @if (responders.length > 0) {
      <div class="form-group">
        <div class="row">
          @for (responder of responders; track responder) {
            <div class="responder-tooltip"
              (mouseover)="toggleTooltipHover($event, responder)"
              (mouseout)="toggleTooltipHover($event, responder)" (click)="toggleTooltipClick($event, responder)">
              <label class="responder">{{responder.lastName}}, {{responder.firstName}}
                <i class="icon-medium icon-delete" (click)="removeResponder(responder)"
                style="float: right; padding-left: 10px;"></i>
                @if (tooltipHover === responder.employeeId || tooltipClick === responder.employeeId) {
                  <span
                    class="tooltiptext">
                    <table>
                      <tr>
                        <td><i>Id:</i> </td>
                        <td> <label> {{responder.employeeId}} </label> </td>
                      </tr>
                      <tr>
                        <td><i>Role:</i> </td>
                        <td> <label> {{responder.jobTitle}} </label> </td>
                      </tr>
                      <tr>
                        <td><i>Dep.:</i> </td>
                        <td> <label> {{responder.departmentDesc </label> </td>
                      </tr>
                      <tr>
                        <td><i>Station:</i> </td>
                        <td> <label> {{responder.stationCode}} </label> </td>
                      </tr>
                    </table>
                  </span>
                }
              </label>
            </div>
          }
        </div>
      </div>
    }
    <form formForward [formGroup]="forwardForm">
      <div class="form-group">
        <label class="" for="inputComment">Comment :</label>
        <textarea class="form-control" formControlName="commentFormControl" rows="8" required
        [(ngModel)]="comments"></textarea>
        @if (commentFormControl.invalid && (commentFormControl.dirty || commentFormControl.touched || !isCommentValid)) {
          <label
          class="validation-fail">Comment is required.</label>
        }
      </div>
    </form>
  </modal-content>
  <modal-footer>
    <button type="button" class="btn-cancel" data-bs-dismiss="modal">Cancel</button>
    <button type="button" class="btn-primary" [disabled]="disableSend" (click)="forward()">Send </button>

  </modal-footer>
</modal>

<modal modalClass="modal-lg " #searchModal (onOpen)="onSearchOpen()" (onClose)="closeSearch($event)">
  <modal-header>
    <h3>Search Responders</h3>
  </modal-header>
  <modal-content (click)="closeTooltip()">

    <div class="modal-body-responsive">
      @if (responders.length > 0) {
        <div class="form-group">
          <label class="responder-font" for="inputResponder">Responder</label>
          <label class="helper-text">Click or hover on responder's name to see details</label>
          <div class="row">
            @for (responder of responders; track responder) {
              <div class="responder-tooltip"
                (mouseover)="toggleTooltipHover($event, responder)"
                (mouseout)="toggleTooltipHover($event, responder)"
                (click)="toggleTooltipClick($event, responder)">
                <label class="responder">{{responder.lastName}}, {{responder.firstName}}
                  <i class="icon-medium icon-delete" (click)="removeResponder(responder)"
                  style="float: right; padding-left: 10px;"></i>
                  @if (tooltipHover == responder.employeeId || tooltipClick == responder.employeeId) {
                    <span
                      class="tooltiptext">
                      <table>
                        <tr>
                          <td><i>Id:</i> </td>
                          <td> <label> {{responder.employeeId}} </label> </td>
                        </tr>
                        <tr>
                          <td><i>Role:</i> </td>
                          <td> <label> {{responder.jobTitle}} </label> </td>
                        </tr>
                        <tr>
                          <td><i>Dep.:</i> </td>
                          <td> <label> {{responder.departmentDesc}} </label> </td>
                        </tr>
                        <tr>
                          <td><i>Station:</i> </td>
                          <td> <label> {{responder.stationCode}} </label> </td>
                        </tr>
                      </table>
                    </span>
                  }
                </label>
              </div>
            }
          </div>
        </div>
      }
      <form formSearch [formGroup]="searchForm">
        <div class="row">
          <div class="col-md-2 col-sm-4  col-xs-6">
            <label class="" for="corpaa">Employee ID</label>
            <input type="text" class="form-control" formControlName="searchFormControl" id="corpaa"
              [(ngModel)]="corpaaId">
            @if (searchFormControl.errors && searchFormControl.dirty) {
              <label
                class="validation-fail">EmployeeID
              accepts only numeric values.</label>
            }
          </div>
          <div class="col-md-2 col-sm-4  col-xs-6">
            <label class="" for="firstName">First Name</label>
            <input type="text" class="form-control" formControlName="firstNameFormControl" id="firstName"
              [(ngModel)]="firstName">
            @if (firstNameFormControl.errors && firstNameFormControl.dirty) {
              <label
                class="validation-fail">First name
              accepts only letters, spaces and dashes.</label>
            }
          </div>
          <div class="col-md-2 col-sm-4  col-xs-6">
            <label class="" for="lastName">Last Name</label>
            <input type="search" class="form-control" formControlName="lastNameFormControl" id="lastName"
              [(ngModel)]="lastName">
            @if (lastNameFormControl.errors && lastNameFormControl.dirty) {
              <label
                class="validation-fail">Last name
              accepts only letters, spaces and dashes</label>
            }
          </div>
          <div class="col-md-2 col-sm-4  col-xs-6">
            <label class="" for="jobTitle">Job Title</label>
            <input type="text" class="form-control" formControlName="jobTitleFormControl" id="jobTitle"
              [(ngModel)]="jobTitle">
            @if (jobTitleFormControl.errors && jobTitleFormControl.dirty) {
              <label
                class="validation-fail">Job title
              name accepts only letters, spaces, numbers, and dashes</label>
            }
          </div>
          <div class="col-md-2 col-sm-4  col-xs-6">
            <label class="" for="departmentSearch">Department</label>
            <input type="text" class="form-control" formControlName="departmentSearchFormControl"
              id="departmentSearch" [(ngModel)]="department">
          </div>
          <div class="col-md-2 col-sm-4  col-xs-6">
            <label class="" for="stationSearch">Station Code</label>
            <input type="text" class="form-control" formControlName="stationSearchFormControl"
              id="stationSearch" [(ngModel)]="stationCode">
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 text-right">
            <button type="submit" class="button-save search-btn" (click)="searchEmployees()">Search</button>
          </div>
        </div>
      </form>
      @if (isExist) {
        <label class="validation-fail">Responder already added</label>
      }
      @if (timeoutError) {
        <label class="validation-fail">Search result is too long. Please refine your search.
        </label>
      }
      <app-aa-spinner [loading]="isLoading"></app-aa-spinner>
      @if (!isLoading && showSearch) {
        <div class="employee-table" style="width: 100%;">
          <table style="width: 100%;" class="reportHistory-table table table-hover table-striped">
            <thead>
            </thead>
            <tbody>
              @for (employee of employees ; track employee) {
                <tr>
                  <td>{{employee.employeeId}}</td>
                  <td>{{employee.lastName}}, {{employee.firstName}}</td>
                  <td>{{employee.jobTitle}}</td>
                  <td>{{employee.departmentDesc}}</td>
                  <td>{{employee.stationCode}}</td>
                  <td (click)="addEmployee(employee)"><a>Add</a></td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      }
    </div>
  </modal-content>
  <modal-footer>
    <button type="button" class="button-cancel" (click)="searchModal.close()">Close</button>
  </modal-footer>
</modal>
